import React from 'react';
import clsx from 'clsx';
import { Typography, Grid, Slider, withStyles } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import { IdentifierData } from '../../Reducers/App/types';
import { useStyles } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedComponent } from '../../Reducers/App/Actions';
import { selectOption } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { ConfiguratorComponent } from '../Forms/types';
import { getSelectedComponentWithOptions } from '../../Reducers/App/Selectors';
import SelectorItem from './SelectorItem';
import { setSurroundingData } from '../../Reducers/Configurator/Actions';
import { getSurroundingData } from '../../Reducers/Configurator/Selectors';

interface SurroundingItemProps {
  item: IdentifierData;
  component?: ConfiguratorComponent;
}

const getRange = (option) => {
  const rangeAttr = option.attributes.find(({ identifier }) => 'range' === identifier);
  if (rangeAttr?.value) {
    if (rangeAttr.value.indexOf('-') !== -1) {
      const [min, max] = rangeAttr.value.split('-').map((str) => parseInt(str));
      return {
        min,
        max,
        step: 5,
      };
    } else if (rangeAttr.value.indexOf(',')) {
      const values = rangeAttr.value.split(',').map((str) => parseInt(str));
      return {
        min: values[0],
        max: values[values.length - 1],
        values,
      };
    }
  }
  return false;
};

const StyledSlider = withStyles({
  track: {
    height: 4,
    marginTop: -1,
  },
})(Slider);

const SurroundingItem: React.FC<SurroundingItemProps> = (props) => {
  const { item } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const options = item.options;

  const handleChange = (value) => dispatch(setSurroundingData(item.identifier, value));
  const value = useSelector(getSurroundingData(item.identifier));

  return (
    <>
      <div className={clsx(classes.row, classes.groupTitle)}>
        <Typography>{item.title}</Typography>
      </div>
      {options.map((option) => {
        const range = getRange(option);

        if (range) {
          return (
            <div className={classes.sliderContainer} key={option.identifier}>
              <div className={classes.sliderWrapper}>
                {range.values ? (
                  <StyledSlider
                    onChange={(evt, value) => handleChange(value)}
                    defaultValue={range.min}
                    valueLabelDisplay="off"
                    step={null}
                    marks={range.values.map((v) => ({ value: v, label: v }))}
                    max={range.max}
                    min={range.min}
                    color="secondary"
                    value={value}
                  />
                ) : (
                  <StyledSlider
                    onChange={(evt, value) => handleChange(value)}
                    defaultValue={range.min}
                    valueLabelDisplay="off"
                    step={range.step}
                    min={range.min}
                    max={range.max}
                    color="secondary"
                    value={value}
                  />
                )}
              </div>
              <div>
                <Typography gutterBottom>{value} m</Typography>
              </div>
            </div>
          );
        }

        const selected = option.identifier === value;
        return (
          <div
            className={clsx(classes.row, classes.item)}
            key={option.identifier}
            onClick={() => handleChange(option.identifier)}
          >
            <Typography className={clsx(selected ? 'selected' : '')}>{option.title}</Typography>
          </div>
        );
      })}
    </>
  );
};

export default SurroundingItem;
